import { render } from "./App.vue?vue&type=template&id=a378eae2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dominikheun/Coding/evgroup-website-typo3-12lts/extensions/jobs/Resources/Private/Vue/job-offer-list/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__